import HeaderV1, { getServerSideProps } from '../../../src/header';

const HeaderPage = () => {
    return <HeaderV1 />;
};

export default HeaderPage;

export { getServerSideProps };
